import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Departamento } from '../page/departamento/departamento';

@Injectable({ providedIn: 'root' })
export class DepartamentoService {

  private apiURL = environment.apiBaseUrl + 'departamento';

  constructor(private http: HttpClient) { }

  listar(): Observable<Departamento[]> {
    return this.http.get<Departamento[]>(this.apiURL);
  }

  listarAtivos(): Observable<Departamento[]> {
    return this.http.get<Departamento[]>(`${this.apiURL}/ativos`);
  }

  buscarPorId(id: number): Observable<Departamento> {
    return this.http.get<Departamento>(`${this.apiURL}/${id}`);
  }

  salvar(departamento: Departamento): Observable<Departamento> {
    if (departamento.id) {
      return this.http.put<Departamento>(`${this.apiURL}/${departamento.id}`, departamento);
    }
    return this.http.post<Departamento>(this.apiURL, departamento);
  }

  inativar(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiURL}/${id}`);
  }
}
